import { ResumenLlaveByClienteProductoUsuario } from '../../bussines/entities/EstadisticasLlave.entity';
import {dataMultiChart} from '../types/multiChart.types';
import {meses} from '../consts/meses';

type fnMapperCantLlavesToDataMultiChar = (params: {
   data: ResumenLlaveByClienteProductoUsuario[];
}) => dataMultiChart[];

export const mapperCantLlavesToDataMultiChar: fnMapperCantLlavesToDataMultiChar = ({
   data
}) => {
   // Objeto de agrupación
   const mesesAgrupados = data.reduce((acc, {producto, usuario, razonsocial, mes, value}) => {
      acc[mes] = acc[mes] || {};
      acc[mes][producto] = acc[mes][producto] || {};
      acc[mes][producto][usuario] = acc[mes][producto][usuario] || {};
      acc[mes][producto][usuario][razonsocial] = acc[mes][producto][usuario][razonsocial] || [];

      acc[mes][producto][usuario][razonsocial].push({
         codigo: razonsocial,
         denominacion: razonsocial,
         value
      });

      return acc;
   }, {} as Record<number, Record<string, Record<string, Record<string, dataMultiChart[]>>>>);

   // Función para sumar el total de los valores de un conjunto de datos
   const sumValues = (data: dataMultiChart[]) => data.reduce((acc, curr) => acc + curr.value, 0);

   // Creamos el objeto final con la suma de valores por mes, producto, usuario y cliente
   const dataPorMeses: dataMultiChart[] = Object.entries(mesesAgrupados).map(([mes, productos]) => {
      const topProductos = Object.entries(productos).map(([producto, usuarios]) => {
         const topUsuarios = Object.entries(usuarios).map(([usuario, clientes]) => {
            const topClientes = Object.entries(clientes).map(([cliente, valores]) => ({
               codigo: cliente,
               denominacion: cliente,
               value: sumValues(valores)
            }));

            return {
               codigo: usuario,
               denominacion: usuario,
               value: sumValues(topClientes),
               subChar: topClientes
            };
         });

         return {
            codigo: producto,
            denominacion: producto,
            value: sumValues(topUsuarios),
            subChar: topUsuarios
         };
      });

      return {
         codigo: mes,
         denominacion: meses[Number(mes) - 1].labelLong, // Nombre completo del mes
         mark: meses[Number(mes) - 1].label, // Abreviatura del mes
         value: sumValues(topProductos),
         subChar: topProductos
      };
   });

   return dataPorMeses;
};
